import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import GetStarted from "components/cta/GetStarted";
import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";

// Images related to iOS tech stack
import IosImage1 from "../../images/ios1.png"; // Add the image for iOS development
import IosImage2 from "../../images/ios2.png"; // Another iOS development-related image
import SwiftIcon from "../../images/icons8-swift-50.png"; // Swift logo
import ObjectiveCIcon from "../../images/objC.webp"; // Objective-C logo
import AutoLayoutIcon from "../../images/icons8-layout-50.png"; // Auto Layout icon
import CoreDataIcon from "../../images/dataIcon.png"; // CoreData icon
import SwiftUIIcon from "../../images/icons8-swift-50.png"; // SwiftUI logo

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
      {/* Hero Section */}
      <TwoColumnWithVideo
        heading="iOS Technologies for Building Modern Mobile Apps"
        buttonRounded={false}
        primaryButtonText="Request Free Consultation"
        primaryButtonUrl="https://calendly.com/solutions-tbnw/30min?month=2024-11"
        description="Our team specializes in iOS app development using Swift, Objective-C, SwiftUI, Auto Layout, and CoreData to create intuitive, high-performance mobile applications. Whether you're building a new app or enhancing an existing one, we can turn your vision into reality."
        imageSrc={IosImage1} // iOS-related image (e.g., iPhone, iOS app design, etc.)
      />

      {/* Main Feature Section */}
      <MainFeature1
        subheading={<Subheading>Our Expertise</Subheading>}
        heading="Ready to Build Your Next iOS App?"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl="/contactus"
        description="We specialize in developing native iOS applications using Objective-C, Swift, SwiftUI, Auto Layout, and CoreData. Our team ensures a seamless user experience with intuitive, high-performance apps that meet your business needs."
        textOnLeft={false}
        imageSrc={IosImage2}
      />

      {/* Feature Section */}
      <Features
        heading="iOS Technology Stack"
        description="Our iOS development team uses a variety of powerful tools and frameworks to create innovative and feature-rich mobile applications. Here's a look at the key technologies we use."
        cards={[
          {
            imageSrc: SwiftIcon,
            title: "Swift",
            description: "Swift is Apple's modern programming language for iOS development, designed for safety, performance, and ease of use. We use Swift to build robust and scalable apps that are both fast and secure."
          },
          {
            imageSrc: ObjectiveCIcon,
            title: "Objective-C",
            description: "Objective-C is a mature, object-oriented programming language that has been used extensively for iOS app development. We continue to work with Objective-C for legacy code and app updates."
          },
          {
            imageSrc: AutoLayoutIcon,
            title: "Auto Layout",
            description: "Auto Layout is a powerful system used to design responsive and adaptable user interfaces. We use Auto Layout to ensure that iOS apps work seamlessly across different device sizes and orientations."
          },
          {
            imageSrc: CoreDataIcon,
            title: "CoreData",
            description: "CoreData is Apple's framework for data persistence and management. We use CoreData to store and manage app data locally, ensuring that apps can function offline and efficiently handle complex data models."
          },
          {
            imageSrc: SwiftUIIcon,
            title: "SwiftUI",
            description: "SwiftUI is Apple's declarative framework for building user interfaces across all Apple platforms. It enables us to design UIs in a faster and more intuitive way, with live previews and dynamic updates."
          }
        ]}
      />

      {/* Get Started Section */}
      <GetStarted />

      {/* Contact Us Section */}
      <TwoColContactUsWithIllustrationFullForm />

      {/* Footer */}
      <Footer />
    </AnimationRevealPage>
  );
};
